import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  connect() {
    this.loaded = false
    this.onTabChange = this.onTabChange.bind(this)
    window.addEventListener("tsc:tab-change", this.onTabChange)
    this.maybeLoad()
  }

  disconnect() {
    window.removeEventListener("tsc:tab-change", this.onTabChange)
    this.loaded = false
  }

  onTabChange() {
    this.maybeLoad()
  }

  maybeLoad() {
    if (this.loaded) return

    const panel = this.element.closest('[role="tabpanel"]')
    if (!panel || panel.hasAttribute("hidden")) return

    this.loaded = true
    this.frameTarget.src = this.urlValue
  }
}
